module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "google-map"
  }, [(_vm.currentFarm.config.location.fallback) ? _c('div', {
    staticClass: "google-map__fallback"
  }, [_c('div', {
    staticClass: "google-map__image",
    style: ('background-image:url(' + _vm.image + ')')
  }), _c('div', {
    staticClass: "google-map__desc"
  }, [_c('div', {
    staticClass: "google-map__wrapper"
  }, [_c('div', {
    staticClass: "google-map__desc-title"
  }, [_vm._v(_vm._s(_vm.currentFarm.config.infos.label))]), _c('div', {
    staticClass: "google-map__desc-subtitle"
  }, [_vm._v(_vm._s(_vm.currentFarm.config.location.label))])])]), _c('div', {
    staticClass: "google-map__legend"
  }, [_vm._v("©2017 Google")])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5527feea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5527feea"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/google-map/GoogleMapComponent.vue
// module id = 821
// module chunks = 0